import { PromptFunction, ExecuteParams, ListContainer, TextContainer } from '../../types';
import { createCustomFunction } from './createFunction';
import { renderExecuteResult } from '../../formatter';
import { sliceTextByWordCount } from '@/utils';


/**
 * 小说相关函数
 * @returns 小说相关函数对象
 */
const novelsFunctions: Record<string, PromptFunction> = {
  asList: createCustomFunction(
    'asList',
    '将给定参数渲染为无序列表',
    (context, ...params: ExecuteParams[]): string => {
      const result = renderExecuteResult(context, params, 'plain', { listType: 'unordered' }).filter(d => d).join('\n').trim()
      return result
    }
  ),
  'asNumberedList': createCustomFunction(
    'asNumberedList',
    '将每个给定参数转换为文本容器，并渲染为有序列表',
    (context, ...params: ExecuteParams[]): string => {
      const result = renderExecuteResult(context, params, 'plain', { listType: 'ordered' }).filter(d => d).join('\n').trim()
      return result
    }
  ),
  'asPlainText': createCustomFunction(
    'asPlainText',
    '将每个给定参数渲染为常规纯文本',
    (context, ...params: ExecuteParams[]): string => {
      const result = renderExecuteResult(context, params, 'plain').filter(d => d).join('\n').trim()
      return result
    }
  ),
  'asXml': createCustomFunction(
    'asXml',
    '将每个给定参数渲染为（嵌套式）XML格式。',
    (context, ...params: ExecuteParams[]): string => {
      const result = renderExecuteResult(context, params, 'xml').filter(d => d).join('\n').trim()
      return result
    }
  ),
  'asMarkdown': createCustomFunction(
    'asMarkdown',
    '将每个给定参数渲染为Markdown格式（嵌套元素将使用递增的标题层级）。',
    (context, ...params: ExecuteParams[]): string => {
      const result = renderExecuteResult(context, params, 'markdown').filter(d => d).join('\n').trim()
      return result
    }
  ),
  'firstWords': createCustomFunction(
    'firstWords',
    '返回指定文本元素的前N个单词，不包括任何标题或属性信息。',
    (context, ...params: ExecuteParams[]): ListContainer<TextContainer> => {
      const num = params.pop();
      const count = typeof num === 'number' && !isNaN(num) ? Number(num) : undefined
      const result: TextContainer[] = params.map(param => {
        const title = renderExecuteResult(context, [param], 'markdown').filter(d => d).join(', ').trim()
        if (!title) return undefined;
        return {
          type: 'textContainer',
          defaultFormat: 'markdown',
          title,
          formatters: {
            markdown: (container: TextContainer) => {
              if (container.title && count) {
                // 提取文本容器中的文本，并返回前N个单词或者字数
                return sliceTextByWordCount(container.title, count, 'end')
              }
            },
          },
        }
      }).filter(d => d) as TextContainer[]
      return {
        type: 'listContainer',
        defaultFormat: 'inherited',
        elements: result,
      }
    }
  ),
  'lastWords': createCustomFunction(
    'lastWords',
    '返回指定文本元素的后N个单词，不包括任何标题或属性信息。',
    (context, ...params: ExecuteParams[]): ListContainer<TextContainer> => {
      const num = params.pop();
      const count = typeof num === 'number' && !isNaN(num) ? Number(num) : undefined
      const result: TextContainer[] = params.map(param => {
        const title = renderExecuteResult(context, [param], 'markdown').filter(d => d).join(', ').trim()
        if (!title) return undefined;
        return {
          type: 'textContainer',
          defaultFormat: 'markdown',
          title,
          formatters: {
            markdown: (container: TextContainer) => {
              if (container.title && count) {
                // 提取文本容器中的文本，并返回前N个单词或者字数
                return sliceTextByWordCount(container.title, count, 'end')
              }
            },
          },
        }
      }).filter(d => d) as TextContainer[]
      return {
        type: 'listContainer',
        defaultFormat: 'inherited',
        elements: result,
      }
    }
  )
}

export default novelsFunctions;